<template>
    <!-- <pre class="language-{{ language }}"><code ref="code" class="language-{{ language }}">{{ code }}</code></pre> -->
    <!-- <pre :class="'language-' + language">
    <code ref="code" :class="'language-' + language">{{ code }}</code>
  </pre> -->
</template>

<script>
// import Prism from 'prismjs';
// import 'prismjs/themes/prism.css';
export default {
    name: 'CodeSnippet',
    props: {
        code: {
            type: String,
            required: true
        },
        language: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.highlightCode();
    },
    methods: {
        highlightCode() {
            // Prism.highlightElement(this.$refs.code);
        }
    }
};
</script>

<style scoped>
pre {
    padding: 1em;
    background: #f5f5f5;
    border-radius: 0.5em;
    overflow: auto;
    max-width: 100%;
}
</style>